<template>
    <DsModal
        is-open
        size="fullscreen"
        show-close
        sticky-desktop-header
        class="automation-email-editor-modal"
        @close="$emit('close')"
    >
        <template #title>
            <div class="title-container">
                <div class="automation-title">
                    <span
                        class="title"
                        data-qa="automation-email-title"
                        :title="title"
                    >
                        {{ title }}
                    </span>

                    <DsStatus
                        data-qa="automation-email-ready-status"
                        class="ready-status-chip"
                        emphasis="high"
                        :type="isReady ? 'good' : 'default'"
                    >
                        {{ status }}
                    </DsStatus>
                </div>

                <div
                    v-if="updatedTime"
                    class="subtitle"
                    data-qa="automation-email-updated-time"
                >
                    {{ updatedTime }}
                </div>
            </div>
        </template>

        <template #header>
            <div class="header">
                <slot name="header" />
            </div>
        </template>

        <template #default>
            <slot name="default" />
        </template>
    </DsModal>
</template>

<script>
export default {
    name: 'AutomationEmailEditorContainer',

    props: {
        isReady: Boolean,
        title: String,
        updatedTime: String,
    },

    computed: {
        status() {
            return this.isReady ? this.$t('funnel.header.readyToggle.ready') : this.$t('funnel.header.readyToggle.draft');
        },
    },
}
</script>

<style lang="scss" scoped>
.automation-email-editor-modal {
    --modal-overflow: hidden;
}

/* border-radius is set to zero by design system if modal is fullscreen
    This is modal displays fullscreen and so it has zero border radius but it is
        causing any modal that exists within this modal to also have zero border radius
        even if it does not occupy fullscreen
    This style will fix it.
*/
.automation-email-editor-modal:deep {
    .modal-overlay:not(.fullscreen) {
        .modal-content-wrapper,
        .modal-header,
        .modal-body {
            border-radius: $border-radius;
            --modal-overflow: visible;
        }

        /* this one is just to counter leaky styles */
        .modal-body {
            padding: 0;
        }
    }
}

.title-container {
    display: flex;
    flex-direction: column;
    gap: $spacing-025;
}

.automation-title {
    display: flex;
    gap: $spacing-100;
}

.subtitle {
    color: $color-text-subtle;
    font-size: $font-size-xs;
}

.title {
    font-size: $font-size-md;
    font-weight: $font-weight-regular;
    max-width: calc(100vw - #{px-to-rem(440)});
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.header {
    display: flex;
    gap: $spacing-200;
    align-items: center;
    margin-right: $spacing-100;
}
</style>
